$box-shadow: 0 0 15px 0 rgb(0 0 0 / 15%);

.ux-date-picker.ux-date-picker--disabled {
  .ux-input[readonly] {
    cursor: not-allowed;
  }
}

.ux-date-picker {
  display: block;
  flex: 1 0 auto;
  max-width: 100%;
  overflow: visible;
  position: relative;
  width: 290px;

  button {
    align-items: center;
    appearance: none;
    background: transparent none;
    border: 0 none transparent;
    border-radius: 0;
    cursor: pointer;
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    outline: none;
  }

  .ux-input[readonly] {
    cursor: pointer;
  }

  &__field {
    background-color: $color-white;
    position: relative;

    ux-icon {
      font-size: 24px;
      pointer-events: none;
      position: absolute;
      right: $dim-15;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &__calendar,
  &__container,
  &__header,
  &__footer,
  &__title {
    align-items: stretch;
    display: flex;
    justify-content: stretch;
  }

  &__container {
    background-color: $color-white;
    box-shadow: $box-shadow;
    flex-direction: column;
    margin-top: $dim-10;
    position: absolute;
    top: 100%;
    width: 290px;
    z-index: $z-index-date-picker-element;
  }

  &__header {
    background-color: $color-blue;
    color: $color-white;
    flex: 1 0 auto;
    flex-flow: row nowrap;

    button {
      color: $color-white;
      height: 44px;
      width: 38px;
    }

    polygon,
    path {
      fill: currentcolor;
    }
  }

  &__title {
    @include font(bold);

    align-items: center;
    flex: 1 0 auto;
    justify-content: center;
    padding: 0 $dim-15;
    text-transform: uppercase;
  }

  &__calendar {
    flex-flow: row wrap;
    padding: $dim-10 $dim-15;

    &-head {
      @include font(bold);

      display: inline-block;
      font-size: $size-text-medium;
      height: 38px;
      text-transform: uppercase;
    }
  }

  &__footer {
    flex-flow: row wrap;
    justify-content: space-between;
    padding: 0 $dim-15 $dim-15;

    button {
      @include font(regular);

      font-size: $size-text-medium-plus;
    }
  }
}

.ux-date-picker--kind-default {
  input {
    caret-color: transparent;
    cursor: pointer;
    border: solid 1px $color-black;
  }

  .ux-label:not(.ux-date-picker__label--top) {
    align-items: center;
    background: $color-blue-70;
    color: $color-black;
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0 15px;
    border: solid 1px $color-black;
    border-right: 0;

    .ux-label--error {
      display: none;
    }
  }

  .ux-input,
  .ux-input:focus {
    border-color: $color-black;
  }

  .ux-input--error {
    border-color: $color-red-error;
  }

  .ux-date-picker__field {
    flex-grow: 1;
  }

  .ux-date-picker__field-wrapper {
    display: flex;
  }
}

.ux-date-picker--kind-form {
  .ux-label {
    display: block;
    font-size: $size-text-small;
    line-height: 1.6;
    margin: 0 0 10px;
    padding: 0;

    [dir="rtl"] & {
      display: flex;
      flex-flow: row wrap;
    }
  }

  .ux-label.ux-label--error {
    @include font(light);

    color: $color-red-error;
  }

  .ux-label ~ .ux-label {
    margin-left: 10px;
  }

  .ux-input--error {
    border-color: $color-red-error;
  }
}

[dir="rtl"] .ux-date-picker__header ux-icon {
  transform: scaleX(-1);
}

[dir="rtl"] .ux-date-picker__field ux-icon {
  left: $dim-15;
  right: auto;
}

.ux-date-picker__calendar-day {
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  font-size: $size-text-small;
  justify-content: center;
  width: calc(100% / 7);

  button {
    background-color: transparent;
    border-radius: 0;
    font-size: inherit;
    height: 38px;
    transition: background-color $animationSpeed-fast ease-out;
    width: 38px;

    &:hover,
    &:focus {
      background-color: $color-green-3;
    }
  }

  &--disabled {
    cursor: not-allowed;
    opacity: 0.3;

    button {
      pointer-events: none;
    }
  }

  &--inactive {
    button {
      opacity: 0.3;
    }
  }

  &--highlighted {
    background-color: $color-green-4;
  }

  &--today {
    button {
      background-color: $color-blue-highlight-6;
    }
  }

  &--selected {
    button,
    button:hover,
    button:focus {
      background-color: $color-green;
    }
  }
}

/** Todo: remove interim styles when consistent error handling is merged **/
.ux-date-picker__label-container {
  .ux-label.ux-label--error {
    @include font(light);

    color: $color-red-error;
  }
}
